{
  "version": 1,
  "image": {
    "file": "docs/reference/cornelis-anthonisz-1538.jpg",
    "width": 2000,
    "height": 1454
  },
  "layout": {
    "position": [
      2411.26,
      1437.54,
      2020.32
    ],
    "target": [
      166.42,
      96.18,
      0.0
    ]
  },
  "three": {
    "position": [
      2411.26,
      2020.32,
      -1437.54
    ],
    "target": [
      166.42,
      0.0,
      -96.18
    ],
    "up": [
      0.0,
      1.0,
      0.0
    ]
  },
  "fovYDeg": 21.13,
  "aspect": 1.37552,
  "yawDeg": 239.14,
  "pitchDeg": -37.69,
  "rollDeg": -0.0,
  "focalPx": 3898.1,
  "principalPoint": [
    1000.0,
    727.0
  ],
  "rmsPx": 98.7,
  "inlierRmsPx": 68.0,
  "robustLoss": {
    "type": "soft_l1",
    "fScalePx": 50.6,
    "weights": "residuals multiplied by sqrt(confidence)"
  },
  "residuals": [
    {
      "id": "schreierstoren",
      "px": 148.8,
      "dx": 129.2,
      "dy": -73.8,
      "outlier": false
    },
    {
      "id": "montelbaanstoren",
      "px": 61.9,
      "dx": -61.4,
      "dy": 7.2,
      "outlier": false
    },
    {
      "id": "waag",
      "px": 18.8,
      "dx": 17.7,
      "dy": -6.2,
      "outlier": false
    },
    {
      "id": "munttoren",
      "px": 29.3,
      "dx": -29.0,
      "dy": 4.2,
      "outlier": false
    },
    {
      "id": "oudekerk",
      "px": 43.4,
      "dx": 35.4,
      "dy": 25.2,
      "outlier": false
    },
    {
      "id": "nieuwekerk",
      "px": 9.3,
      "dx": -6.4,
      "dy": 6.6,
      "outlier": false
    },
    {
      "id": "sint-antoniessluis",
      "px": 81.7,
      "dx": -81.6,
      "dy": 2.8,
      "outlier": false
    },
    {
      "id": "oudezijds-kolk-junction",
      "px": 77.6,
      "dx": 77.1,
      "dy": -9.1,
      "outlier": false
    },
    {
      "id": "grimburgwal-rokin",
      "px": 78.8,
      "dx": 77.9,
      "dy": -12.3,
      "outlier": false
    },
    {
      "id": "grimburgwal-voorburgwal",
      "px": 45.3,
      "dx": 42.4,
      "dy": -16.0,
      "outlier": false
    },
    {
      "id": "grimburgwal-achterburgwal",
      "px": 53.1,
      "dx": 49.4,
      "dy": -19.6,
      "outlier": false
    },
    {
      "id": "swych-utrecht",
      "px": 40.2,
      "dx": 21.4,
      "dy": -34.1,
      "outlier": false
    },
    {
      "id": "heiligewegspoort",
      "px": 50.2,
      "dx": -50.1,
      "dy": 3.7,
      "outlier": false
    },
    {
      "id": "jan-roodenpoort",
      "px": 66.3,
      "dx": -66.2,
      "dy": 3.5,
      "outlier": false
    },
    {
      "id": "haarlemmerpoort",
      "px": 222.3,
      "dx": -209.6,
      "dy": 74.1,
      "outlier": true
    },
    {
      "id": "sint-olofskapel",
      "px": 43.6,
      "dx": 27.8,
      "dy": -33.5,
      "outlier": false
    },
    {
      "id": "nieuwe-brug",
      "px": 31.1,
      "dx": -30.7,
      "dy": -5.0,
      "outlier": false
    },
    {
      "id": "dam",
      "px": 44.5,
      "dx": 41.5,
      "dy": 16.0,
      "outlier": false
    },
    {
      "id": "volewijck",
      "px": 249.3,
      "dx": -146.7,
      "dy": 201.5,
      "outlier": true
    },
    {
      "id": "korsjespoort",
      "px": 130.5,
      "dx": -121.5,
      "dy": 47.7,
      "outlier": false
    }
  ],
  "conventions": "Layout: x east, y north, z up (m), origin 52.3731 N 4.8926 E. three.js: (X, Y, Z) = (x, z, -y). yaw = compass bearing of the view direction (deg, clockwise from north); pitch = elevation of the view direction (deg, negative down); roll = rotation about the view axis (deg, positive turns the image counter-clockwise). Pixels: 2000 x 1454 frame, x right, y down, principal point at the image centre; fovYDeg is the full vertical field of view.",
  "diagnostics": {
    "rollFree": {
      "position": [
        2693.04,
        1913.79,
        2180.07
      ],
      "yawDeg": 234.06,
      "pitchDeg": -35.1,
      "rollDeg": 5.45,
      "fovYDeg": 17.2,
      "principalPoint": [
        1000.0,
        727.0
      ],
      "rmsPx": 86.8,
      "inlierRmsPx": 75.1
    },
    "freePrincipalPoint": {
      "position": [
        3220.53,
        2070.38,
        2558.42
      ],
      "yawDeg": 241.3,
      "pitchDeg": -27.62,
      "rollDeg": -0.0,
      "fovYDeg": 15.18,
      "principalPoint": [
        1343.7,
        0.0
      ],
      "rmsPx": 90.0,
      "inlierRmsPx": 79.1
    },
    "modelLadder": [
      {
        "model": "affine (parallel projection of the ground plan)",
        "parameters": 6,
        "rmsPx": 107.6,
        "medianPx": 68.7
      },
      {
        "model": "pinhole, roll 0, centred principal point (primary)",
        "parameters": 6,
        "rmsPx": 98.7,
        "medianPx": 51.7
      },
      {
        "model": "pinhole, roll free",
        "parameters": 7,
        "rmsPx": 86.8,
        "medianPx": 49.0
      },
      {
        "model": "homography (any planar projective map)",
        "parameters": 8,
        "rmsPx": 72.2,
        "medianPx": 47.7
      },
      {
        "model": "pinhole, roll 0, principal point free",
        "parameters": 8,
        "rmsPx": 90.0,
        "medianPx": 56.3
      }
    ],
    "horizon": {
      "paintedRowPx": 145.1,
      "paintedTiltDeg": 0.107,
      "columnsUsed": 38,
      "cameraRowPx": -2284.5
    },
    "verticalExaggeration": [
      {
        "id": "schreierstoren-top",
        "heightM": 20.0,
        "paintedHeightPx": 69.5,
        "predictedHeightPx": 19.6,
        "ratio": 3.54
      }
    ],
    "leaveOneOut": {
      "positionRangeM": [
        1044.9,
        491.0,
        1007.5
      ],
      "yawRangeDeg": 3.29,
      "pitchRangeDeg": 4.52,
      "fovYRangeDeg": 7.24,
      "predictionErrors": [
        {
          "id": "schreierstoren",
          "px": 205.0
        },
        {
          "id": "montelbaanstoren",
          "px": 183.8
        },
        {
          "id": "waag",
          "px": 21.5
        },
        {
          "id": "munttoren",
          "px": 79.8
        },
        {
          "id": "oudekerk",
          "px": 58.0
        },
        {
          "id": "nieuwekerk",
          "px": 18.5
        },
        {
          "id": "sint-antoniessluis",
          "px": 134.8
        },
        {
          "id": "oudezijds-kolk-junction",
          "px": 108.2
        },
        {
          "id": "grimburgwal-rokin",
          "px": 76.8
        },
        {
          "id": "grimburgwal-voorburgwal",
          "px": 37.0
        },
        {
          "id": "grimburgwal-achterburgwal",
          "px": 45.3
        },
        {
          "id": "swych-utrecht",
          "px": 32.4
        },
        {
          "id": "heiligewegspoort",
          "px": 82.2
        },
        {
          "id": "jan-roodenpoort",
          "px": 64.4
        },
        {
          "id": "haarlemmerpoort",
          "px": 232.6
        },
        {
          "id": "sint-olofskapel",
          "px": 66.6
        },
        {
          "id": "nieuwe-brug",
          "px": 14.8
        },
        {
          "id": "dam",
          "px": 57.7
        },
        {
          "id": "volewijck",
          "px": 269.6
        },
        {
          "id": "korsjespoort",
          "px": 124.7
        }
      ]
    },
    "unfitted": [
      {
        "id": "schreierstoren-top",
        "px": 139.3,
        "dx": 137.1,
        "dy": -24.4,
        "outlier": false
      }
    ]
  },
  "residualWarp": {
    "method": "Horizontal and vertical shifts from rendered to painted pixels are fitted separately to the fitted ground correspondences minus the camera-fit outliers, and to points spread along the lines tools/painterWarp/evidence.json names, whose painted pixels slide along the painted line to where the fitted warp draws them (sliding semilandmarks, settled by alternating the slide and the fit); each misfit is weighted by its confidence (as in the camera fit). The vertical one is fitted as (v - 145.1) h(u, v) so the painted horizon row cannot move, and held below the lowest fitted point, whose row it keeps down every column. Candidates: no warp, weighted polynomials of degree 0-2 and smoothing thin-plate splines with an affine part, smoothing 1e-3 to 1e3 at 8 steps per decade. Each is scored by leave-one-out prediction; the one-standard-error rule keeps, of the models within one standard error of the best mean square, the one with the fewest effective parameters (trace of the hat matrix), so the field does not bend through single points.",
    "scalePx": 1000,
    "smoothing": 0.023714,
    "centresPx": [
      [
        977.202,
        1192.338
      ],
      [
        256.55,
        1144.345
      ],
      [
        627.712,
        909.899
      ],
      [
        372.96,
        404.314
      ],
      [
        917.376,
        877.251
      ],
      [
        1126.53,
        594.744
      ],
      [
        243.339,
        802.896
      ],
      [
        970.068,
        1050.952
      ],
      [
        599.829,
        442.764
      ],
      [
        532.358,
        517.081
      ],
      [
        512.376,
        537.51
      ],
      [
        366.834,
        532.536
      ],
      [
        565.922,
        293.815
      ],
      [
        1281.751,
        531.563
      ],
      [
        1047.764,
        1056.555
      ],
      [
        1144.24,
        1035.065
      ],
      [
        929.445,
        626.107
      ],
      [
        1456.001,
        733.764
      ],
      [
        181.951,
        1193.824
      ],
      [
        167.066,
        1200.92
      ],
      [
        152.12,
        1208.045
      ],
      [
        137.113,
        1215.2
      ],
      [
        122.044,
        1222.384
      ],
      [
        106.913,
        1229.597
      ],
      [
        160.172,
        824.776
      ],
      [
        131.147,
        832.285
      ],
      [
        101.981,
        839.831
      ],
      [
        72.674,
        847.414
      ],
      [
        43.224,
        855.034
      ],
      [
        13.63,
        862.691
      ]
    ],
    "weights": [
      -584.497009,
      26.460793,
      245.267133,
      156.178864,
      84.936419,
      -125.090829,
      225.711678,
      -262.529163,
      -705.822629,
      137.860888,
      -124.989703,
      -340.026259,
      470.010287,
      -5.316863,
      268.070518,
      412.450843,
      -59.676414,
      132.951828,
      -51.238176,
      13.433988,
      13.736003,
      17.865907,
      22.548652,
      29.029258,
      0.504874,
      0.546975,
      0.529536,
      0.470235,
      0.380395,
      0.241969
    ],
    "affine": [
      106.767205,
      -36.951744,
      -153.57992
    ],
    "vertical": {
      "heldRowPx": 145.1,
      "lastFittedRowPx": 1229.597,
      "smoothing": 0.013335,
      "centresPx": [
        [
          977.202,
          1192.338
        ],
        [
          256.55,
          1144.345
        ],
        [
          627.712,
          909.899
        ],
        [
          372.96,
          404.314
        ],
        [
          917.376,
          877.251
        ],
        [
          1126.53,
          594.744
        ],
        [
          243.339,
          802.896
        ],
        [
          970.068,
          1050.952
        ],
        [
          599.829,
          442.764
        ],
        [
          532.358,
          517.081
        ],
        [
          512.376,
          537.51
        ],
        [
          366.834,
          532.536
        ],
        [
          565.922,
          293.815
        ],
        [
          1281.751,
          531.563
        ],
        [
          1047.764,
          1056.555
        ],
        [
          1144.24,
          1035.065
        ],
        [
          929.445,
          626.107
        ],
        [
          1456.001,
          733.764
        ],
        [
          181.951,
          1193.824
        ],
        [
          167.066,
          1200.92
        ],
        [
          152.12,
          1208.045
        ],
        [
          137.113,
          1215.2
        ],
        [
          122.044,
          1222.384
        ],
        [
          106.913,
          1229.597
        ],
        [
          160.172,
          824.776
        ],
        [
          131.147,
          832.285
        ],
        [
          101.981,
          839.831
        ],
        [
          72.674,
          847.414
        ],
        [
          43.224,
          855.034
        ],
        [
          13.63,
          862.691
        ]
      ],
      "weights": [
        372.866122,
        725.760426,
        -122.076558,
        -142.34197,
        -252.140338,
        82.237959,
        41.697997,
        -372.845276,
        42.789305,
        35.410684,
        79.149417,
        242.519197,
        -32.206006,
        128.159551,
        328.581604,
        -98.682593,
        -89.397506,
        -202.390357,
        -119.905912,
        -79.059387,
        -81.348535,
        -92.463366,
        -117.515356,
        -152.353844,
        -29.012789,
        -30.391849,
        -27.446973,
        -21.431605,
        -13.157224,
        -3.004819
      ],
      "affine": [
        -14.438145,
        105.190933,
        -11.136145
      ],
      "minColumnSlopeFrame": 0.6641,
      "minColumnSlopeCanvas": 0.5564,
      "maxShiftFramePx": 167.75,
      "maxShiftCanvasPx": 396.49,
      "maxCurvaturePerPx": 0.009792
    },
    "excluded": [
      "haarlemmerpoort",
      "volewijck"
    ],
    "looRmsPx": 46.32,
    "looRmsNoWarpPx": 68.04,
    "fitRmsPx": 17.18,
    "canvasPx": [
      [
        -1000,
        -1100
      ],
      [
        3000,
        2560
      ]
    ],
    "minJacobianFrame": 0.5526,
    "minJacobianCanvas": 0.5204,
    "maxShiftFramePx": 253.74,
    "maxShiftCanvasPx": 525.93,
    "maxCurvaturePerPx": 0.007602,
    "points": [
      {
        "id": "schreierstoren",
        "renderedPx": [
          977.202,
          1192.338
        ],
        "paintedPx": [
          848,
          1266
        ],
        "confidence": 0.9,
        "residualPx": 148.73,
        "warpedResidualPx": 16.28,
        "looPx": 94.28,
        "leverage": 0.812
      },
      {
        "id": "montelbaanstoren",
        "renderedPx": [
          256.55,
          1144.345
        ],
        "paintedPx": [
          318,
          1137
        ],
        "confidence": 0.8,
        "residualPx": 61.89,
        "warpedResidualPx": 12.13,
        "looPx": 49.81,
        "leverage": 0.67
      },
      {
        "id": "waag",
        "renderedPx": [
          627.712,
          909.899
        ],
        "paintedPx": [
          610,
          916
        ],
        "confidence": 0.8,
        "residualPx": 18.73,
        "warpedResidualPx": 7.74,
        "looPx": 40.49,
        "leverage": 0.807
      },
      {
        "id": "munttoren",
        "renderedPx": [
          372.96,
          404.314
        ],
        "paintedPx": [
          402,
          400
        ],
        "confidence": 0.7,
        "residualPx": 29.36,
        "warpedResidualPx": 11.72,
        "looPx": 24.15,
        "leverage": 0.703
      },
      {
        "id": "oudekerk",
        "renderedPx": [
          917.376,
          877.251
        ],
        "paintedPx": [
          882,
          852
        ],
        "confidence": 0.5,
        "residualPx": 43.46,
        "warpedResidualPx": 10.03,
        "looPx": 23.79,
        "leverage": 0.582
      },
      {
        "id": "nieuwekerk",
        "renderedPx": [
          1126.53,
          594.744
        ],
        "paintedPx": [
          1133,
          588
        ],
        "confidence": 0.5,
        "residualPx": 9.35,
        "warpedResidualPx": 7.68,
        "looPx": 16.87,
        "leverage": 0.589
      },
      {
        "id": "sint-antoniessluis",
        "renderedPx": [
          243.339,
          802.896
        ],
        "paintedPx": [
          325,
          800
        ],
        "confidence": 0.7,
        "residualPx": 81.71,
        "warpedResidualPx": 7.74,
        "looPx": 19.13,
        "leverage": 0.596
      },
      {
        "id": "oudezijds-kolk-junction",
        "renderedPx": [
          970.068,
          1050.952
        ],
        "paintedPx": [
          893,
          1060
        ],
        "confidence": 0.7,
        "residualPx": 77.6,
        "warpedResidualPx": 11.86,
        "looPx": 25.5,
        "leverage": 0.502
      },
      {
        "id": "grimburgwal-rokin",
        "renderedPx": [
          599.829,
          442.764
        ],
        "paintedPx": [
          522,
          455
        ],
        "confidence": 0.6,
        "residualPx": 78.78,
        "warpedResidualPx": 28.08,
        "looPx": 57.02,
        "leverage": 0.509
      },
      {
        "id": "grimburgwal-voorburgwal",
        "renderedPx": [
          532.358,
          517.081
        ],
        "paintedPx": [
          490,
          533
        ],
        "confidence": 0.6,
        "residualPx": 45.25,
        "warpedResidualPx": 5.84,
        "looPx": 8.9,
        "leverage": 0.353
      },
      {
        "id": "grimburgwal-achterburgwal",
        "renderedPx": [
          512.376,
          537.51
        ],
        "paintedPx": [
          463,
          557
        ],
        "confidence": 0.6,
        "residualPx": 53.08,
        "warpedResidualPx": 6.67,
        "looPx": 10.18,
        "leverage": 0.384
      },
      {
        "id": "swych-utrecht",
        "renderedPx": [
          366.834,
          532.536
        ],
        "paintedPx": [
          345.5,
          566.5
        ],
        "confidence": 0.4,
        "residualPx": 40.11,
        "warpedResidualPx": 29.01,
        "looPx": 45.44,
        "leverage": 0.43
      },
      {
        "id": "heiligewegspoort",
        "renderedPx": [
          565.922,
          293.815
        ],
        "paintedPx": [
          616,
          290
        ],
        "confidence": 0.4,
        "residualPx": 50.22,
        "warpedResidualPx": 28.78,
        "looPx": 84.26,
        "leverage": 0.668
      },
      {
        "id": "jan-roodenpoort",
        "renderedPx": [
          1281.751,
          531.563
        ],
        "paintedPx": [
          1348,
          528
        ],
        "confidence": 0.5,
        "residualPx": 66.34,
        "warpedResidualPx": 8.85,
        "looPx": 16.96,
        "leverage": 0.715
      },
      {
        "id": "sint-olofskapel",
        "renderedPx": [
          1047.764,
          1056.555
        ],
        "paintedPx": [
          1020,
          1090
        ],
        "confidence": 0.4,
        "residualPx": 43.47,
        "warpedResidualPx": 19.93,
        "looPx": 30.32,
        "leverage": 0.324
      },
      {
        "id": "nieuwe-brug",
        "renderedPx": [
          1144.24,
          1035.065
        ],
        "paintedPx": [
          1175,
          1040
        ],
        "confidence": 0.3,
        "residualPx": 31.15,
        "warpedResidualPx": 32.97,
        "looPx": 63.51,
        "leverage": 0.479
      },
      {
        "id": "dam",
        "renderedPx": [
          929.445,
          626.107
        ],
        "paintedPx": [
          888,
          610
        ],
        "confidence": 0.4,
        "residualPx": 44.46,
        "warpedResidualPx": 7.13,
        "looPx": 13.67,
        "leverage": 0.584
      },
      {
        "id": "korsjespoort",
        "renderedPx": [
          1456.001,
          733.764
        ],
        "paintedPx": [
          1577.5,
          686
        ],
        "confidence": 0.4,
        "residualPx": 130.55,
        "warpedResidualPx": 13.91,
        "looPx": 71.64,
        "leverage": 0.83
      }
    ],
    "slidingPoints": [
      {
        "id": "ij-dike-east-1",
        "line": "ij-dike-east",
        "renderedPx": [
          181.951,
          1193.824
        ],
        "paintedPx": [
          252,
          1112
        ],
        "confidence": 0.2,
        "residualPx": 107.71,
        "warpedResidualPx": 9.75,
        "looPx": 11.53,
        "leverage": 0.137
      },
      {
        "id": "ij-dike-east-2",
        "line": "ij-dike-east",
        "renderedPx": [
          167.066,
          1200.92
        ],
        "paintedPx": [
          248.051,
          1110.744
        ],
        "confidence": 0.2,
        "residualPx": 121.2,
        "warpedResidualPx": 5.24,
        "looPx": 6.2,
        "leverage": 0.135
      },
      {
        "id": "ij-dike-east-3",
        "line": "ij-dike-east",
        "renderedPx": [
          152.12,
          1208.045
        ],
        "paintedPx": [
          236.334,
          1107.015
        ],
        "confidence": 0.2,
        "residualPx": 131.53,
        "warpedResidualPx": 5.36,
        "looPx": 6.35,
        "leverage": 0.142
      },
      {
        "id": "ij-dike-east-4",
        "line": "ij-dike-east",
        "renderedPx": [
          137.113,
          1215.2
        ],
        "paintedPx": [
          224.895,
          1103.128
        ],
        "confidence": 0.2,
        "residualPx": 142.36,
        "warpedResidualPx": 6.14,
        "looPx": 7.44,
        "leverage": 0.16
      },
      {
        "id": "ij-dike-east-5",
        "line": "ij-dike-east",
        "renderedPx": [
          122.044,
          1222.384
        ],
        "paintedPx": [
          213.319,
          1098.884
        ],
        "confidence": 0.2,
        "residualPx": 153.57,
        "warpedResidualPx": 7.75,
        "looPx": 9.92,
        "leverage": 0.194
      },
      {
        "id": "ij-dike-east-6",
        "line": "ij-dike-east",
        "renderedPx": [
          106.913,
          1229.597
        ],
        "paintedPx": [
          201.74,
          1094.638
        ],
        "confidence": 0.2,
        "residualPx": 164.94,
        "warpedResidualPx": 9.98,
        "looPx": 14.24,
        "leverage": 0.247
      },
      {
        "id": "sint-antoniesdijk-1",
        "line": "sint-antoniesdijk",
        "renderedPx": [
          160.172,
          824.776
        ],
        "paintedPx": [
          259.755,
          799.329
        ],
        "confidence": 0.3,
        "residualPx": 102.78,
        "warpedResidualPx": 1.9,
        "looPx": 2.33,
        "leverage": 0.198
      },
      {
        "id": "sint-antoniesdijk-2",
        "line": "sint-antoniesdijk",
        "renderedPx": [
          131.147,
          832.285
        ],
        "paintedPx": [
          238.64,
          798.977
        ],
        "confidence": 0.3,
        "residualPx": 112.54,
        "warpedResidualPx": 1.97,
        "looPx": 2.38,
        "leverage": 0.182
      },
      {
        "id": "sint-antoniesdijk-3",
        "line": "sint-antoniesdijk",
        "renderedPx": [
          101.981,
          839.831
        ],
        "paintedPx": [
          217.046,
          798.617
        ],
        "confidence": 0.3,
        "residualPx": 122.22,
        "warpedResidualPx": 1.76,
        "looPx": 2.12,
        "leverage": 0.178
      },
      {
        "id": "sint-antoniesdijk-4",
        "line": "sint-antoniesdijk",
        "renderedPx": [
          72.674,
          847.414
        ],
        "paintedPx": [
          195.003,
          798.25
        ],
        "confidence": 0.3,
        "residualPx": 131.84,
        "warpedResidualPx": 1.36,
        "looPx": 1.67,
        "leverage": 0.194
      },
      {
        "id": "sint-antoniesdijk-5",
        "line": "sint-antoniesdijk",
        "renderedPx": [
          43.224,
          855.034
        ],
        "paintedPx": [
          172.532,
          797.876
        ],
        "confidence": 0.3,
        "residualPx": 141.38,
        "warpedResidualPx": 0.82,
        "looPx": 1.09,
        "leverage": 0.245
      },
      {
        "id": "sint-antoniesdijk-6",
        "line": "sint-antoniesdijk",
        "renderedPx": [
          13.63,
          862.691
        ],
        "paintedPx": [
          149.645,
          797.498
        ],
        "confidence": 0.3,
        "residualPx": 150.83,
        "warpedResidualPx": 0.19,
        "looPx": 0.29,
        "leverage": 0.362
      }
    ],
    "candidates": [
      {
        "component": "horizontal",
        "model": "none",
        "parameter": 0,
        "looRmsPx": 81.62,
        "effectiveParameters": 0,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "polynomial",
        "parameter": 0,
        "looRmsPx": 78.03,
        "effectiveParameters": 1,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "polynomial",
        "parameter": 1,
        "looRmsPx": 73.89,
        "effectiveParameters": 3,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "polynomial",
        "parameter": 2,
        "looRmsPx": 39.33,
        "effectiveParameters": 6,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.001,
        "looRmsPx": 25.59,
        "effectiveParameters": 21.908,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.001334,
        "looRmsPx": 25.68,
        "effectiveParameters": 21.223,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.001778,
        "looRmsPx": 25.81,
        "effectiveParameters": 20.513,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.002371,
        "looRmsPx": 26,
        "effectiveParameters": 19.777,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.003162,
        "looRmsPx": 26.26,
        "effectiveParameters": 19.012,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.004217,
        "looRmsPx": 26.61,
        "effectiveParameters": 18.217,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.005623,
        "looRmsPx": 27.04,
        "effectiveParameters": 17.389,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.007499,
        "looRmsPx": 27.56,
        "effectiveParameters": 16.532,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.01,
        "looRmsPx": 28.17,
        "effectiveParameters": 15.649,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.013335,
        "looRmsPx": 28.86,
        "effectiveParameters": 14.746,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.017783,
        "looRmsPx": 29.64,
        "effectiveParameters": 13.83,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.023714,
        "looRmsPx": 30.47,
        "effectiveParameters": 12.912,
        "chosen": true
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.031623,
        "looRmsPx": 31.37,
        "effectiveParameters": 12.001,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.04217,
        "looRmsPx": 32.32,
        "effectiveParameters": 11.108,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.056234,
        "looRmsPx": 33.32,
        "effectiveParameters": 10.244,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.074989,
        "looRmsPx": 34.38,
        "effectiveParameters": 9.418,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.1,
        "looRmsPx": 35.53,
        "effectiveParameters": 8.638,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.133352,
        "looRmsPx": 36.82,
        "effectiveParameters": 7.91,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.177828,
        "looRmsPx": 38.34,
        "effectiveParameters": 7.238,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.237137,
        "looRmsPx": 40.14,
        "effectiveParameters": 6.623,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.316228,
        "looRmsPx": 42.3,
        "effectiveParameters": 6.066,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.421697,
        "looRmsPx": 44.82,
        "effectiveParameters": 5.568,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.562341,
        "looRmsPx": 47.67,
        "effectiveParameters": 5.126,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 0.749894,
        "looRmsPx": 50.75,
        "effectiveParameters": 4.741,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 1,
        "looRmsPx": 53.91,
        "effectiveParameters": 4.408,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 1.333521,
        "looRmsPx": 57.02,
        "effectiveParameters": 4.127,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 1.778279,
        "looRmsPx": 59.93,
        "effectiveParameters": 3.892,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 2.371374,
        "looRmsPx": 62.55,
        "effectiveParameters": 3.7,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 3.162278,
        "looRmsPx": 64.82,
        "effectiveParameters": 3.544,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 4.216965,
        "looRmsPx": 66.73,
        "effectiveParameters": 3.42,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 5.623413,
        "looRmsPx": 68.31,
        "effectiveParameters": 3.322,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 7.498942,
        "looRmsPx": 69.57,
        "effectiveParameters": 3.246,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 10,
        "looRmsPx": 70.58,
        "effectiveParameters": 3.187,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 13.335214,
        "looRmsPx": 71.36,
        "effectiveParameters": 3.142,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 17.782794,
        "looRmsPx": 71.97,
        "effectiveParameters": 3.107,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 23.713737,
        "looRmsPx": 72.43,
        "effectiveParameters": 3.081,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 31.622777,
        "looRmsPx": 72.79,
        "effectiveParameters": 3.061,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 42.16965,
        "looRmsPx": 73.06,
        "effectiveParameters": 3.046,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 56.234133,
        "looRmsPx": 73.26,
        "effectiveParameters": 3.034,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 74.989421,
        "looRmsPx": 73.42,
        "effectiveParameters": 3.026,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 100,
        "looRmsPx": 73.54,
        "effectiveParameters": 3.019,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 133.352143,
        "looRmsPx": 73.62,
        "effectiveParameters": 3.015,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 177.827941,
        "looRmsPx": 73.69,
        "effectiveParameters": 3.011,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 237.137371,
        "looRmsPx": 73.74,
        "effectiveParameters": 3.008,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 316.227766,
        "looRmsPx": 73.78,
        "effectiveParameters": 3.006,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 421.696503,
        "looRmsPx": 73.81,
        "effectiveParameters": 3.005,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 562.341325,
        "looRmsPx": 73.83,
        "effectiveParameters": 3.003,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 749.894209,
        "looRmsPx": 73.84,
        "effectiveParameters": 3.003,
        "chosen": false
      },
      {
        "component": "horizontal",
        "model": "thinPlate",
        "parameter": 1000,
        "looRmsPx": 73.86,
        "effectiveParameters": 3.002,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "none",
        "parameter": 0,
        "looRmsPx": 56.69,
        "effectiveParameters": 0,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "polynomial",
        "parameter": 0,
        "looRmsPx": 52.13,
        "effectiveParameters": 1,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "polynomial",
        "parameter": 1,
        "looRmsPx": 40.82,
        "effectiveParameters": 3,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "polynomial",
        "parameter": 2,
        "looRmsPx": 22.9,
        "effectiveParameters": 6,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.001,
        "looRmsPx": 17.05,
        "effectiveParameters": 19.262,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.001334,
        "looRmsPx": 17.17,
        "effectiveParameters": 18.394,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.001778,
        "looRmsPx": 17.3,
        "effectiveParameters": 17.509,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.002371,
        "looRmsPx": 17.47,
        "effectiveParameters": 16.611,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.003162,
        "looRmsPx": 17.66,
        "effectiveParameters": 15.705,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.004217,
        "looRmsPx": 17.9,
        "effectiveParameters": 14.797,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.005623,
        "looRmsPx": 18.19,
        "effectiveParameters": 13.895,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.007499,
        "looRmsPx": 18.54,
        "effectiveParameters": 13.006,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.01,
        "looRmsPx": 18.95,
        "effectiveParameters": 12.136,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.013335,
        "looRmsPx": 19.45,
        "effectiveParameters": 11.291,
        "chosen": true
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.017783,
        "looRmsPx": 20.03,
        "effectiveParameters": 10.476,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.023714,
        "looRmsPx": 20.72,
        "effectiveParameters": 9.695,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.031623,
        "looRmsPx": 21.53,
        "effectiveParameters": 8.951,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.04217,
        "looRmsPx": 22.46,
        "effectiveParameters": 8.249,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.056234,
        "looRmsPx": 23.52,
        "effectiveParameters": 7.59,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.074989,
        "looRmsPx": 24.69,
        "effectiveParameters": 6.978,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.1,
        "looRmsPx": 25.96,
        "effectiveParameters": 6.414,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.133352,
        "looRmsPx": 27.33,
        "effectiveParameters": 5.9,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.177828,
        "looRmsPx": 28.75,
        "effectiveParameters": 5.436,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.237137,
        "looRmsPx": 30.2,
        "effectiveParameters": 5.022,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.316228,
        "looRmsPx": 31.65,
        "effectiveParameters": 4.659,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.421697,
        "looRmsPx": 33.04,
        "effectiveParameters": 4.344,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.562341,
        "looRmsPx": 34.35,
        "effectiveParameters": 4.077,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 0.749894,
        "looRmsPx": 35.52,
        "effectiveParameters": 3.853,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 1,
        "looRmsPx": 36.55,
        "effectiveParameters": 3.669,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 1.333521,
        "looRmsPx": 37.43,
        "effectiveParameters": 3.52,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 1.778279,
        "looRmsPx": 38.16,
        "effectiveParameters": 3.401,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 2.371374,
        "looRmsPx": 38.75,
        "effectiveParameters": 3.308,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 3.162278,
        "looRmsPx": 39.23,
        "effectiveParameters": 3.235,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 4.216965,
        "looRmsPx": 39.6,
        "effectiveParameters": 3.179,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 5.623413,
        "looRmsPx": 39.89,
        "effectiveParameters": 3.135,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 7.498942,
        "looRmsPx": 40.11,
        "effectiveParameters": 3.102,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 10,
        "looRmsPx": 40.28,
        "effectiveParameters": 3.077,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 13.335214,
        "looRmsPx": 40.42,
        "effectiveParameters": 3.058,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 17.782794,
        "looRmsPx": 40.51,
        "effectiveParameters": 3.044,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 23.713737,
        "looRmsPx": 40.59,
        "effectiveParameters": 3.033,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 31.622777,
        "looRmsPx": 40.65,
        "effectiveParameters": 3.025,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 42.16965,
        "looRmsPx": 40.69,
        "effectiveParameters": 3.019,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 56.234133,
        "looRmsPx": 40.72,
        "effectiveParameters": 3.014,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 74.989421,
        "looRmsPx": 40.75,
        "effectiveParameters": 3.01,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 100,
        "looRmsPx": 40.76,
        "effectiveParameters": 3.008,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 133.352143,
        "looRmsPx": 40.78,
        "effectiveParameters": 3.006,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 177.827941,
        "looRmsPx": 40.79,
        "effectiveParameters": 3.004,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 237.137371,
        "looRmsPx": 40.8,
        "effectiveParameters": 3.003,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 316.227766,
        "looRmsPx": 40.8,
        "effectiveParameters": 3.002,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 421.696503,
        "looRmsPx": 40.81,
        "effectiveParameters": 3.002,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 562.341325,
        "looRmsPx": 40.81,
        "effectiveParameters": 3.001,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 749.894209,
        "looRmsPx": 40.81,
        "effectiveParameters": 3.001,
        "chosen": false
      },
      {
        "component": "vertical",
        "model": "thinPlate",
        "parameter": 1000,
        "looRmsPx": 40.81,
        "effectiveParameters": 3.001,
        "chosen": false
      }
    ]
  }
}
